import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: '测试环境',
  environment: 'test',
  apiSrc: 'https://saas-api.vansunscience.com',
  questionarySrc: 'https://que-design.vansunscience.com',
};
